(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-scroll-target]').forEach(element => {
      const target = document.querySelector(element.getAttribute('data-scroll-target'));
      if (target) {
        element.classList.add('sb-blog-post__author-name--clickable');
        element.addEventListener('click', (e) => {
          e.preventDefault();
          window.scrollTo({ top: target.offsetTop - 20, behavior: 'smooth' });
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
